

































import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { SearchOption } from '@front-app/components/search/useSearch';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { UserStore } from '@front-app/store/singletons/User';
import SearchGroupUsers from '@front-app/components/inputs/SearchGroupUsers.vue';
import SelectedUserButton from '@front-app/components/buttons/SelectedUserButton.vue';
import EditEventBaseForm from './EditEventBaseForm.vue';
import { useEventAdminStore } from '../../store/EventAdmin';

export default defineComponent({
	components: {
		EditEventBaseForm,
		SearchGroupUsers,
		SelectedUserButton,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const groupId = computed(() => props.eventData.groupIds[0]);
		const speakers = syncedRef(() => props.eventData.speakers.filter(Boolean)).ref;
		watch(() => props.eventData.speakers, (curr) => {
			UserStore.getInstance().fetchMany(curr);
		}, { immediate: true });
		const removeSpeakerById = (val: string) => {
			speakers.value = speakers.value.filter((_) => _ !== val);
		};
		const addSpeaker = (speaker: SearchOption<UserSearchItem>) => {
			UserStore.getInstance().setPartial(speaker.original);
			speakers.value = [...speakers.value, speaker.original.id];
		};

		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const saveUpdates = async () => {
			await track(useEventAdminStore().update(props.eventData.id, {
				speakers: speakers.value,
			}));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			groupId,
			speakers,
			removeSpeakerById,
			addSpeaker,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
